import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { financialObligationApi } from '@/api/commercial/financial-obligations';
import { FinancialReceiptTable } from '@/components/table/financial/financial-receipt-table';

export function FinancialReceiptsListPage() {
  const [pendingOnly, setPendingOnly] = useState(true);
  const [page, setPage] = useState(1);
  const limit = 25;
  const query = useQuery({
    queryKey: ['financial-obligations', { pendingOnly, page }],
    queryFn: () => financialObligationApi.findPaymentConfirmations({ pendingOnly, page, limit }),
  });
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold">Comprovantes</h1>
      <label className="flex gap-2">
        <input
          type="checkbox"
          checked={pendingOnly}
          onChange={(event) => {
            setPendingOnly(event.target.checked);
            setPage(1);
          }}
        />
        Somente pendentes
      </label>
      {query.isLoading ? (
        <p>Carregando confirmações de pagamento...</p>
      ) : query.isError ? (
        <p role="alert" className="text-red-600">
          Não foi possível carregar os comprovantes.
        </p>
      ) : query.data?.length ? (
        <FinancialReceiptTable data={query.data} />
      ) : (
        <p>Nenhuma confirmação de pagamento encontrada.</p>
      )}
      <button type="button" disabled={query.isFetching} onClick={() => void query.refetch()}>
        {query.isFetching ? 'Atualizando...' : 'Atualizar comprovantes'}
      </button>
      <nav aria-label="Paginação" className="flex items-center gap-3">
        <button
          type="button"
          disabled={page === 1 || query.isFetching}
          onClick={() => setPage(page - 1)}
        >
          Anterior
        </button>
        <span>Página {page}</span>
        <button
          type="button"
          disabled={query.isFetching || query.isError || (query.data?.length ?? 0) < limit}
          onClick={() => setPage(page + 1)}
        >
          Próxima
        </button>
      </nav>
    </div>
  );
}
